import React, { useState, useEffect, useRef } from "react";
// import axios from 'axios';
import './Bankdetails.css';
import Select from 'react-select';
import { useSearchParams, useLocation } from 'react-router-dom';
import { bandkDetailsSubmit, getEmployeeDetailsBasedonEmployeeUniqueeId, getAccountTypes } from "../../../../../../services/employeeCreationService";
import { formatAccountHolderName, isAlphabet, formatBranchName, validateIfscCode, validateAccountNumber, formatBankName, getFileName } from "../../../../../../utils/validations";
import { selectStyles, selectStyleDisable } from "../../../../../../assets/Styles/selectStyle";
import { getAuditLog } from "../../../../../../utils/calculateDaysInMonthUtils";
import ConfirmModal from "../../../../../../components/common/ConfirmModal/ConfirmModal";
const Bankdetails = ({ onPrevious, onNext }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const fromUrl = searchParams.get('employeeUniqueId');   // <-- from query string
  const fromState = location.state?.applicationId;        // <-- from navigation state

  // Use the URL value **only if it exists** – otherwise fall back to state
  const employeeUniqueId = fromUrl ?? fromState;
  const [completed, setCompleted] = useState(false);   // <-- NEW
  const isLocked = Boolean(fromUrl && completed);
  //const employeeUniqueId = searchParams.get('employeeUniqueId') || location.state?.applicationId;
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const effectRan = useRef(false);
  const [bankData, setBankData] = useState({
    accountHolderName: "",
    accountNumber: "",
    bankName: "",
    branchName: "",
    ifscCode: "",
    accountType: "",
    passbookFileName: "",
    verified:false,
  });
  const [personalInfo, setPersonalInfo] = useState({
    givenName: "",
    surname: "",
    jobPosition: "",
  });
  const [errors, setErrors] = useState({
    accountHolderName: '',
    accountNumber: '',
    bankName: '',
    branchName: '',
    ifscCode: '',
    accountType: '',
    passbookFileName: '',
  });
  const [isFocused, setIsFocused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // Load saved bank data from localStorage
  useEffect(() => {
    const savedBankData = JSON.parse(localStorage.getItem('bankData'));
    if (savedBankData && JSON.stringify(savedBankData) !== JSON.stringify(bankData)) {
      setBankData(savedBankData);
    }
  }, []);

  // Validate form and update isNextDisabled
  useEffect(() => {
    const isAccountHolderNameValid = bankData.accountHolderName.trim() !== '';
    const isAccountNumberValid = validateAccountNumber(bankData.accountNumber);
    const isIfscCodeValid = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankData.ifscCode);
    const isAccountTypeValid = bankData.accountType !== '';
    const isNoAccountNumberError = !errors.accountNumber;

    // console.log('Validation State:', {
    //   isAccountHolderNameValid,
    //   isAccountNumberValid,
    //   isIfscCodeValid,
    //   isAccountTypeValid,
    //   isNoAccountNumberError,
    //   bankData,
    //   errors
    // });

    setIsNextDisabled(
      !(isAccountHolderNameValid && isAccountNumberValid && isIfscCodeValid && isAccountTypeValid && isNoAccountNumberError)
    );
  }, [bankData, errors.accountNumber]);


  // Save bank data to localStorage
  useEffect(() => {
    localStorage.setItem('bankData', JSON.stringify(bankData));
  }, [bankData]);

  // Fetch account types
  useEffect(() => {
    const fetchAccountTypes = async () => {
      try {
        const data = await getAccountTypes();
        const options = data.map((item) => ({
          value: item.id,
          label: item.accountTypeName,
        }));
        setAccountTypes(options);
      } catch (err) {
        console.error("Error fetching account types:", err);
      }
    };

    if (!effectRan.current) {
      fetchAccountTypes();
    }
    return () => {
      effectRan.current = true;
    }


  }, []);

  // Fetch application details
  useEffect(() => {
    const fetchApplicationDetails = async () => {
      if (!employeeUniqueId) return;
      try {
        const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
        console.log("Fetched application data:", appData); // Debug the response
        if (appData.bankDetails && appData.bankDetails.length > 0) {
          setBankData({
            id: appData.bankDetails[0].id || "",
            accountHolderName: appData.bankDetails[0].accountHolderName || "",
            accountNumber: appData.bankDetails[0].accountNumber || "",
            bankName: appData.bankDetails[0].bankName || "",
            branchName: appData.bankDetails[0].branchName || "",
            ifscCode: appData.bankDetails[0].ifscCode || "",
            accountType: appData.bankDetails[0].accountType?.id || "",
            passbookFileName: appData.bankDetails[0].passbookFileName || "",
         verified: appData.bankDetails[0].verified === true,  // ← SET THIS
          });
        } else {
          setBankData({
            accountHolderName: "",
            accountNumber: "",
            bankName: "",
            branchName: "",
            ifscCode: "",
            accountType: "",
            passbookFileName: "",
          });
        }
        setCompleted(appData.completed === true);
        setPersonalInfo({
          givenName: appData.givenName || appData.employee?.firstName || "",
          surname: appData.surname || appData.employee?.lastName || "",
          jobPosition: appData.employee?.jobPosition?.designationName || "",
        });
      } catch (error) {
        console.error("Error fetching application data:", error);
      }
    };
    if (!effectRan.current) {
      fetchApplicationDetails();
      setIsDirty(false);
    }
    return () => {
      effectRan.current = true;
    };
  }, [employeeUniqueId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const textOnlyFields = ["bankName", "branchName", "accountHolderName"];
    const onlyTextRegex = /^[A-Za-z\s]*$/;

    if (textOnlyFields.includes(name) && !onlyTextRegex.test(value)) {
      return;
    }

    const formattedValue =
      name === "accountHolderName" ? formatAccountHolderName(value) :
        name === "bankName" ? formatBankName(value) :
          name === "branchName" ? formatBranchName(value) : value;

    setBankData(prev => ({ ...prev, [name]: formattedValue }));
    setErrors(prev => ({ ...prev, [name]: '' })); // Clear error for the field
    setIsDirty(true);
  };

  const handleAccountChange = (e) => {
    if (e?.target) {
      const { name, value } = e.target;
      if (name === "accountNumber" && !validateAccountNumber(value)) {
        setErrors(prev => ({
          ...prev,
          accountNumber: "Only numbers allowed, max 15 digits",
        }));
        return;
      }
      setBankData(prev => ({ ...prev, [name]: value }));
      setErrors(prev => ({ ...prev, [name]: '' }));
    } else if (e?.value) {
      setBankData(prev => ({ ...prev, accountType: e.value }));
      setErrors(prev => ({ ...prev, accountType: '' }));
    }
    setIsDirty(true);
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setBankData(prev => ({
        ...prev,
        [fieldName]: file.name,
      }));
      if (!window._uploadedFiles) {
        window._uploadedFiles = {};
      }
      window._uploadedFiles[fieldName] = file;
      setErrors(prev => ({ ...prev, [fieldName]: '' }));
    }
    setIsDirty(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isNextDisabled) return;

    const formDataObj = new FormData();
    const fullName = localStorage.getItem("full_name");
    const role = localStorage.getItem("role");
    const employeeId = localStorage.getItem("employeeId");

    const bankDetails = {
      ...(bankData.id ? { id: bankData.id } : {}),
      accountHolderName: bankData.accountHolderName,
      accountNumber: bankData.accountNumber,
      bankName: bankData.bankName,
      branchName: bankData.branchName,
      ifscCode: bankData.ifscCode,
      ...(bankData.accountType ? { accountType: { id: bankData.accountType } } : { accountType: null }),
    };

    const requestPayload = { bankDetails };
    if (employeeId && role) {
      // requestPayload.auditLog = {
      //   name: fullName,
      //   role,
      //   employeeId,
      // };
      requestPayload.auditLog = getAuditLog();
    }

    formDataObj.append("request", new Blob([JSON.stringify(requestPayload)], { type: "application/json" }));
    if (window._uploadedFiles?.bankPassbook) {
      formDataObj.append("file", window._uploadedFiles.bankPassbook);
    }

    try {
      // const response = await axios.post(
      //   `${process.env.REACT_APP_API_BASE_URL}/api/bank-details/${employeeUniqueId}`,
      //   formDataObj,
      //   { headers: { "Content-Type": "multipart/form-data" } }
      // );
      const response = await bandkDetailsSubmit(employeeUniqueId, formDataObj);
      if (response.status === 200 || response.status === 201) {
        setShowPopup(true);
        setErrors({ ...errors, accountNumber: '' }); // Clear any existing errors
        setBankData({
          accountHolderName: "",
          accountNumber: "",
          bankName: "",
          branchName: "",
          ifscCode: "",
          accountType: "",
          passbookFileName: "",
        });
        localStorage.removeItem('bankData'); // Clear localStorage
        onNext();
      }
    } catch (error) {
      console.error("Error saving bank details:", error);
      if (error.response?.data?.error) {
        if (error.response.data.error.includes("account number")) {
          setErrors(prev => ({
            ...prev,
            accountNumber: error.response.data.error, // Set backend error
          }));
        } else {
          console.log("Backend error:", error.response.data.error);
        }
      } else {
        setErrors(prev => ({
          ...prev,
          accountNumber: "An unexpected error occurred. Please try again.",
        }));
      }
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // const formatAccountHolderName = (str) => {
  //   if (!str) return "";
  //   return str.toUpperCase();
  // };

  // const formatBankName = (input) => {
  //   if (!input) return "";
  //   let value = input.replace(/[^a-zA-Z &-]/g, "");
  //   return value
  //     .split(/\s+/)
  //     .map((word, idx) => {
  //       if (!word) return "";
  //       const lower = word.toLowerCase();
  //       if ((lower === "of" || lower === "and") && idx !== 0) {
  //         return lower;
  //       }
  //       if (word === "&" || word === "-") {
  //         return word;
  //       }
  //       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  //     })
  //     .join(" ");
  // };



  const handlePreviousClick = () => {
    const isFormEmpty =
      !bankData.accountHolderName &&
      !bankData.accountNumber &&
      !bankData.bankName &&
      !bankData.branchName &&
      !bankData.ifscCode &&
      !bankData.accountType &&
      !bankData.passbookFileName;
    if (isFormEmpty || !isDirty) {
      onPrevious();
    } else {
      setShowConfirmModal(true);
    }
  };

  const handleConfirmYes = () => {
    setBankData({
      accountHolderName: "",
      accountNumber: "",
      bankName: "",
      branchName: "",
      ifscCode: "",
      accountType: "",
      passbookFileName: "",
    });
    localStorage.removeItem('bankData');
    setShowConfirmModal(false);
    onPrevious();
  };

  const handleConfirmNo = () => {
    setShowConfirmModal(false);
  };

  return (
    <React.Fragment>
      <div className="bankdetails-container">
        <div className="bankdetails-box">
          <form onSubmit={handleSubmit}>
            <div className="bandetails-heading">
              <span className="highlight-label">Temporary ID : </span>
              {employeeUniqueId} - {personalInfo.givenName} {personalInfo.surname} - {personalInfo.jobPosition}
            </div>
            <h2 className="bankdetails-heading">Bank Details</h2>
            <div className="floating-label-container">
              <input
                type="text"
                name="accountHolderName"
                value={bankData.accountHolderName}
                onChange={(e) => {
                  let value = e.target.value;
                  if (isAlphabet(value)) {
                    value = formatAccountHolderName(value);
                    handleChange({ target: { name: "accountHolderName", value } });
                  }
                }}
                required
                placeholder=" "
                disabled={isLocked}
              />
              <label>
                <span className="required">*</span> Name as per Bank Account
              </label>
              {errors.accountHolderName && (
                <p className="error">{errors.accountHolderName}</p>
              )}
            </div>
            <div className="floating-label-container">
              <input
                type="text"
                inputMode="numeric"               // shows numeric keypad on mobile
                name="accountNumber"
                value={bankData.accountNumber}
                onChange={(e) => {
                  // 1. Keep only digits
                  const raw = e.target.value.replace(/\D/g, '');
                  // 2. Enforce max length (18 – matches backend)
                  const value = raw.slice(0, 18);

                  // 3. Update state immediately
                  setBankData(prev => ({ ...prev, accountNumber: value }));

                  // 4. Real-time error feedback (optional)
                  if (value.length === 0) {
                    setErrors(prev => ({ ...prev, accountNumber: '' }));
                  } else if (value.length < 9) {
                    setErrors(prev => ({
                      ...prev,
                      accountNumber: 'Minimum 9 digits required',
                    }));
                  } else if (value.length > 18) {
                    setErrors(prev => ({
                      ...prev,
                      accountNumber: 'Maximum 18 digits allowed',
                    }));
                  } else {
                    setErrors(prev => ({ ...prev, accountNumber: '' }));
                  }

                  setIsDirty(true);
                }}
                maxLength={18}
                required
                placeholder=" "
                disabled={isLocked}
              />
              <label>
                <span className="required">*</span>Account Number
              </label>
              {errors.accountNumber && (
                <p className="error">{errors.accountNumber}</p>
              )}
            </div>
            <div
              className={`floating-label-container ${bankData.accountType || isFocused ? "float-label" : ""}`}
            >
              <Select
                options={accountTypes}
                value={accountTypes.find((opt) => opt.value === bankData.accountType) || null}
                onChange={handleAccountChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(!!bankData.accountType)}
                placeholder=""
                // styles={{
                //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                //   control: provided => ({ ...provided, padding: '1px' }),
                //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
                // }}

                isDisabled={isLocked}
                styles={isLocked ? selectStyleDisable : selectStyles}
              />
              <label>
                <span className="required">*</span>Account Type
              </label>
              {errors.accountType && (
                <p className="error">{errors.accountType}</p>
              )}
            </div>
            <div className="floating-label-container">
              <input
                type="text"
                name="bankName"
                value={bankData.bankName}
                onChange={(e) => {
                  const formatted = formatBankName(e.target.value);
                  handleChange({ target: { name: "bankName", value: formatted } });
                }}
                placeholder=""
                disabled={isLocked}
              />
              <label>Bank Name</label>
              {errors.bankName && <p className="error">{errors.bankName}</p>}
            </div>
            <div className="floating-label-container">
              <input
                type="text"
                name="branchName"
                value={bankData.branchName}
                onChange={(e) => {
                  const formatted = formatBranchName(e.target.value);
                  handleChange({ target: { name: "branchName", value: formatted } });
                }}
                placeholder=""
                disabled={isLocked}
              />
              <label>Branch Name</label>
              {errors.branchName && <p className="error">{errors.branchName}</p>}
            </div>
            <div className="floating-label-container">
              <input
                type="text"
                name="ifscCode"
                placeholder=""
                value={bankData.ifscCode}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setBankData(prev => ({ ...prev, ifscCode: value }));
                  const error = validateIfscCode(value); // Use the validation function
                  setErrors(prev => ({ ...prev, ifscCode: error }));
                }}
                maxLength={11}
                pattern="^[A-Z]{4}0[A-Z0-9]{6}$"
                title="The IFSC code is an 11-character code: The first 4 characters are uppercase letters (bank code), followed by a '0', and the last 6 characters can be alphanumeric (branch code)."
                style={{ borderColor: errors.ifscCode ? 'red' : undefined }}
                disabled={isLocked}
              />
              <label>
                <span className="required">*</span>IFSC Code
              </label>
              {errors.ifscCode && (
                <p className="error">{errors.ifscCode}</p>
              )}
            </div>
            <div className="eductiondetails-input-containers">
  <label>Upload Cancel Cheque / Bank Statement</label>
  {(() => {
    const disableFileInput = isLocked && bankData.verified === true;
    return (
      <input
        type="file"
        name="bankPassbook"
        onChange={(e) => handleFileChange(e, 'bankPassbook')}
        disabled={disableFileInput}
      />
    );
  })()}
  {bankData.passbookFileName && (
    <span className="file-name">
      {/* {typeof bankData.passbookFileName === 'string'
        ? bankData.passbookFileName.split('/').pop().split('_').pop()
        : bankData.passbookFileName.name} */}
        {getFileName(bankData.passbookFileName)}
    </span>
  )}
</div>
            <div className="bankdetails-btn">
              <button
                type="button"
                className="bankdetails-btn-previous"
                onClick={handlePreviousClick}
              >
                Previous
              </button>
              <button
                type="submit"
                className="experiencedetails-btn-next"
                disabled={isNextDisabled}
              >
                Save & Next
              </button>
            </div>
          </form>
        </div>
        {/* {showConfirmModal && (
          <div className="modal-overlay">
            <div className="custom-modal">
              <p>Do you want to clear the form?</p>
              <div className="modal-buttons">
                <button type="button" onClick={handleConfirmYes}>
                  Yes
                </button>
                <button type="button" onClick={handleConfirmNo}>
                  No
                </button>
              </div>
            </div>
          </div>
        )} */}
        {showConfirmModal && (
          <ConfirmModal
            message="Do you want to clear the form?"
            onConfirm={handleConfirmYes}
            onCancel={handleConfirmNo}
          />
        )}
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <h3>Bank Details Saved Successfully</h3>
              <button onClick={closePopup}>Close</button>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Bankdetails;